export const getOverviewCommentTitle = (overviewComment) => {
    if(!overviewComment) {
        return  "";
    }

    if(
        overviewComment
        && overviewComment.comment
        && !overviewComment.eventName
        && overviewComment.attachments
        && overviewComment.attachments.length > 0
    ) {
        return "Comment and Document(s) Added";
    }

    if(
        overviewComment
        && !overviewComment.comment
        && !overviewComment.eventName
        && overviewComment.attachments
        && overviewComment.attachments.length > 0
    ) {
        return "Document(s) Added";
    }

    if(
        overviewComment
        && overviewComment.comment
        && !overviewComment.eventName
        && overviewComment.attachments
        && overviewComment.attachments.length === 0
    ) {
        return "Comment Added";
    }

    if(
        overviewComment
        && overviewComment.eventName
        && (
            overviewComment.eventName === "Application Form Change Approved"
            || overviewComment.eventName === "Application Form Change Rejected"
            || overviewComment.eventName === "Application Form Changed"
        )
    ) {
        return overviewComment.eventName;
    }
};